
    import './styles.scoped.css';
    export default {
  "divider": "awsui_divider_1noo2_14r5x_18",
  "divider-horizontal": "awsui_divider-horizontal_1noo2_14r5x_56",
  "divider-has-label": "awsui_divider-has-label_1noo2_14r5x_63",
  "divider-line": "awsui_divider-line_1noo2_14r5x_72",
  "divider-label": "awsui_divider-label_1noo2_14r5x_79",
  "divider-vertical": "awsui_divider-vertical_1noo2_14r5x_85"
};
  